import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AuthPage.scss";

const AuthPage: React.FC = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (isSignup && password !== confirmPassword) {
      toast.error("Passwords do not match!");
      setLoading(false);
      return;
    }

    try {
      const endpoint = isSignup ? "signup.php" : "login.php";
      const payload = isSignup ? { name, email, password } : { email, password };

      const response = await fetch(`https://sjmpolytechnicbirur.in/api/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        toast.success(data.message);
        if (!isSignup) {
          localStorage.setItem("user", JSON.stringify(data.user));
          navigate(data.user.role === "admin" ? "/grievance/admindashboard" : 
                  data.user.role === "lecturer" ? "/grievance/lecturerdashboard" : "/grievance/dashboard");
        } else {
          setIsSignup(false);
        }
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      setLoading(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://sjmpolytechnicbirur.in/api/forgot_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        toast.success("Password reset email sent!");
        setIsForgotPassword(false);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Error sending reset email.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{isForgotPassword ? "Forgot Password" : isSignup ? "Sign Up" : "Login"}</h2>
        <form onSubmit={isForgotPassword ? handleForgotPassword : handleSubmit}>
          {isSignup && !isForgotPassword && (
            <div className="input-group">
              <FontAwesomeIcon icon={faUser} className="icon" />
              <input
                type="text"
                placeholder="Enter Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          )}
          <div className="input-group">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {!isForgotPassword && (
            <>
              <div className="input-group">
                <FontAwesomeIcon icon={faLock} className="icon" />
                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {isSignup && (
                <div className="input-group">
                  <FontAwesomeIcon icon={faLock} className="icon" />
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
              )}
            </>
          )}
          <button type="submit" disabled={loading}>
            {loading ? "Processing..." : isForgotPassword ? "Reset Password" : isSignup ? "Sign Up" : "Login"}
          </button>
        </form>
        <p className="switch-auth">
          {isForgotPassword ? (
            <span onClick={() => setIsForgotPassword(false)}>Back to Login</span>
          ) : (
            <>
              {isSignup ? "Already have an account? " : "Don't have an account? "}
              <span onClick={() => setIsSignup(!isSignup)}>{isSignup ? "Login" : "Sign up"}</span>
              <br />
              <span className="forgot-password" onClick={() => setIsForgotPassword(true)}>
                Forgot Password?
              </span>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default AuthPage;
